import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { ModalComponent } from "src/app/modal/modal.component";
import {
  showInlineLoader,
  hideInlineLoader,
} from "src/app/_actions/inline-loader.actions";
import { HomeService } from "src/app/_services/home.service";
import { PrismicService } from "src/app/_services/prismic.service";
import brandInfo from "src/environments/brand.json";
import { VerifyVehicleModalTriggerService } from "src/app/_services/verify-vehicle-modal-trigger.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-slice-preview",
  standalone: false,
  templateUrl: "./slice-preview.component.html",
  styleUrls: ["./slice-preview.component.scss"],
})
export class SlicePreviewComponent implements OnInit, OnDestroy {
  uid: string;
  slice: any;
  brand: string;
  vehicleObject: any = {
    year: "2019",
    model: {name: "E-tron"},
    make: {name: "Audi"},
    trim: null,
    vin: "WA111111111111111",
  };


  modalRef: MDBModalRef;
  private verifyVehicleCtaSub: Subscription;

  constructor(
    private home: HomeService,
    private route: ActivatedRoute,
    private modalService: MDBModalService,
    private store: Store<{}>,
    private verifyVehicleModalTrigger: VerifyVehicleModalTriggerService
  ) {}



  ngOnInit() {





    this.uid = this.route.snapshot.paramMap.get("uid");
    this.brand = brandInfo.brand;

    this.store.dispatch(showInlineLoader());



    console.log("this.uid: ", this.uid);
    this.home.getContentBlockByUid(this.uid).then((contentBlock) => {
      this.slice = {
        type: 'content_block',
        primary: {
          margin_top: null,
          margin_bottom: null,
          class_name: "",
        },
        fields: [contentBlock.data]
      };

      console.log("SlicePreviewComponent this.slice", this.slice);

      this.store.dispatch(hideInlineLoader());
    });

    this.verifyVehicleCtaSub = this.verifyVehicleModalTrigger.onTrigger.subscribe(() => this.openModal(null));
  }

  ngOnDestroy() {
    if (this.verifyVehicleCtaSub) {
      this.verifyVehicleCtaSub.unsubscribe();
    }
  }

  openModal(data) {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      scroll: true,
      ignoreBackdropClick: false,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true,
      data: {
        heading: "Let's Meet Your Car",
        content: {
          heading: "Content heading",
          description: "Content description",
        },
        vehicle: this.vehicleObject,
        leadData: null,
      },
    };

    this.modalRef = this.modalService.show(ModalComponent, modalOptions);

    const modalRefSubscription = this.modalRef.content.action.subscribe(
      (result: any) => {
        // console.log(result);
        modalRefSubscription.unsubscribe();
      }
    );
  }
}
